export const SUMMARY_TAG_NAME = "summary";
